// @ts-nocheck
export default function (router) {
    router.push(
        {
            path: '/pc',
            redirect: '/pc/index'
        },
        {
            path: '/pc/index',
            component: () => (import("@/components/pc/index")),
            children: [
                {
                    path: '/',
                    meta: {
                        title: '首页',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/home")),
                },
                {
                    path: '/pc/home',
                    name: 'home',
                    meta: {
                        title: '首页',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/home")),
                },
                {
                    path: '/pc/projectInfo',
                    name: 'projectInfo',
                    meta: {
                        title: '项目信息',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/projectInfo")),
                },
                {
                    path: '/pc/operationConfig',
                    name: 'operationConfig',
                    meta: {
                        title: '操作配置',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/operationConfig")),
                },
                {
                    path: '/pc/errList',
                    name: 'errList',
                    meta: {
                        title: '预警列表',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/errlist")),
                },
                {
                    path: '/pc/ammeter',
                    name: 'ammeter',
                    meta: {
                        title: '莹木智联监测平台',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/ammeter")),
                },
                {
                    path: '/pc/ammeterDetails',
                    name: 'ammeterDetails',
                    meta: {
                        title: '联网灯具监测详情',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/ammeterDetails")),
                },
                {
                    path: '/pc/fullScreenMap',
                    name: 'fullScreenMap',
                    meta: {
                        title: '地图编辑',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/fullScreenMap")),
                },
                {
                    path: '/pc/acConfig',
                    name: 'acConfig',
                    meta: {
                        title: '空调配置',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/module/device/newAc")),
                },
                {
                    path: '/pc/adBox',
                    name: 'adBox',
                    meta: {
                        title: '广告灯箱',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/module/device/adBox")),
                },
                {
                    path: '/pc/waterSaving',
                    name: 'waterSaving',
                    meta: {
                        title: '节水管理',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/module/device/waterSaving")),
                },
                {
                    path: '/pc/homeV2',
                    name: 'homeV2',
                    meta: {
                        title: '能耗主页V2',
                        requireAuth: true
                    },
                    component: () => (import("@/components/pc/homeV2")),
                },
            ]
        },
        {
            path: '/pc/login',
            name: 'pclogin',
            meta: {
                title: '登录',
                requireAuth: false
            },
            component: () => import("@/components/pc/login.vue")
        }
    )
}


// WEBPACK FOOTER //
// ./src/router/modules/pc.js